import { naturalCompare } from './utils';

/** Picker options can store a value separately from their label and filter group. */
export type ReferenceItem = string | { value: string, label: string, group?: string };
export type References = Record<string, ReferenceItem[]>;

/** The string actually written into the field when this option is picked. */
export function referenceValue(item: ReferenceItem): string {
  return typeof item === 'string' ? item : item.value;
}

/** What the editor shows for this option. Falls back to the value for plain references. */
export function referenceLabel(item: ReferenceItem): string {
  return typeof item === 'string' ? item : (item.label || item.value);
}

/** Keep the last option for each value and sort labels with numbers in order. */
export function dedupeReferenceItems(items: ReferenceItem[]): ReferenceItem[] {
  const byValue = new Map<string, ReferenceItem>();
  for (const item of items) {
    const value = referenceValue(item);
    if (value === undefined || value === null) continue;
    byValue.set(value, item);
  }
  return [...byValue.values()].sort((a, b) => naturalCompare(referenceLabel(a), referenceLabel(b)));
}
